import { HttpClient } from '@angular/common/http';
import { Provider } from '@angular/core';
import { SentryService } from '@bca-core/services/sentry.service';
import { APP_CONFIG, IAppConfiguration } from '@bca-shared/models/config';
import { IModuleTranslationOptions, ModuleTranslateLoader } from '@larscom/ngx-translate-module-loader';
import { TranslateLoader } from '@ngx-translate/core';

export function ModuleHttpLoaderFactory(
  http: HttpClient,
  sentry: SentryService,
  { staticsPath }: IAppConfiguration
): ModuleTranslateLoader {
  const baseTranslateUrl = `${staticsPath}/assets/i18n`;

  const options: IModuleTranslationOptions = {
    translateError: (error, path) => sentry.logError(error, { path }),
    modules: [
      { baseTranslateUrl },
      { moduleName: 'receipt', baseTranslateUrl },
      { moduleName: 'compose', baseTranslateUrl },
      { moduleName: 'user_data', baseTranslateUrl },
      { moduleName: 'company_data', baseTranslateUrl },
      { moduleName: 'verify', baseTranslateUrl },
      { moduleName: 'agreement', baseTranslateUrl },
      { moduleName: 'confirmation', baseTranslateUrl }
    ]
  };

  return new ModuleTranslateLoader(http, options);
}

export function provideI18n(): Provider {
  return {
    provide: TranslateLoader,
    useFactory: ModuleHttpLoaderFactory,
    deps: [HttpClient, SentryService, APP_CONFIG]
  };
}
